import moment from 'moment';

export default angular
  .module('app.formatting')
  .filter('gmwFormatDate', gmwFormatDate)
  .name;

function gmwFormatDate() {
  'ngInject';

  return formatDate;

  function formatDate(input, format = 'YYYY-MMM-DD') {
    return moment(input).format(format);
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/formatting/filters/format-date.js